import { OrderDto, OrderResourceApi } from "../generated/print-client";
import { AxiosPromise } from "axios";
import { printApiConfig, ops } from "./config";

const orderApi = new OrderResourceApi(printApiConfig);

const OrdersApi = {
  get(id: string): AxiosPromise<OrderDto> {
    return orderApi.get2(id, ops())
  },

  getDraftOrder(locationId: number): AxiosPromise<OrderDto> {
    return orderApi.getDraft(locationId, ops());
  },

  getDraftItemsCount(memberId: number): AxiosPromise<number> {
    return orderApi.getDraftItemsCount(memberId, ops());
  },

  updateOrder(order: OrderDto): AxiosPromise<OrderDto> {
    return orderApi.updateOrder(order, ops());
  },

  submitOrder(order: OrderDto): AxiosPromise<OrderDto> {
    return orderApi.submit(order, ops());
  },

  removeItem(orderId: string, itemId: string): AxiosPromise<OrderDto> {
    return orderApi.removeItem(orderId, itemId, ops());
  },

  updateItemQuantity(orderId: string, itemId: string, newQuantity: string, newPrice: string, newShipping: string): AxiosPromise<OrderDto> {
    return orderApi.updateItemQuantity(orderId, itemId, newQuantity, newPrice, newShipping, ops());
  },

  getExpectedDeliveryDate(orderId: string): AxiosPromise<any> {
    return orderApi.getExpectedDeliveryDate(orderId, ops());
  },

  getLocationOrders(locationId: number): AxiosPromise<OrderDto[]> {
    return orderApi.getLocationOrders(locationId, ops());
  },

  getCheckoutMessage(): AxiosPromise<string> {
    return orderApi.getCheckoutMessage(ops());
  },

  
};

export default OrdersApi;
